import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({
  template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon">' 
  + '</div><center><img src="/btap/assets/img/btap-ico-270x270.png" height="48px"></center></div>',
})
